module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//9_Master.png?v=d8f5bc29";